"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRealm = exports.validateDomain = exports.isDevEnv = void 0;
var enum_1 = require("./enum");
var constants_1 = require("./constants");
var isDevEnv = function () {
    return process.env.NODE_ENV === constants_1.test ||
        process.env.NODE_ENV === constants_1.dev ||
        process.env.NODE_ENV === constants_1.development;
};
exports.isDevEnv = isDevEnv;
var validateDomain = function (domain) {
    if (domain && Object.values(enum_1._domain).includes(domain)) {
        return true;
    }
    else {
        console.error('Domain is Invalid. Please check if its not empty/null or an invalid value');
        return false;
    }
};
exports.validateDomain = validateDomain;
var validateRealm = function (realm) {
    if (realm && Object.values(enum_1._realm).includes(realm)) {
        return true;
    }
    else {
        console.error('Realm is Invalid. Please check if its not empty/null or an invalid value');
        return false;
    }
};
exports.validateRealm = validateRealm;
